__turbopack_context__.v({
  "addedToCartFooterRow": "R77P8G_addedToCartFooterRow",
  "aeCityList": "R77P8G_aeCityList",
  "aeCityOption": "R77P8G_aeCityOption",
  "closeButton": "R77P8G_closeButton",
  "descriptionSection": "R77P8G_descriptionSection",
  "descriptionText": "R77P8G_descriptionText",
  "detailItem": "R77P8G_detailItem",
  "detailItemDescription": "R77P8G_detailItemDescription",
  "detailItemTitle": "R77P8G_detailItemTitle",
  "detailsList": "R77P8G_detailsList",
  "divider": "R77P8G_divider",
  "finalAddToCartButton": "R77P8G_finalAddToCartButton",
  "headerInfo": "R77P8G_headerInfo",
  "headerPrice": "R77P8G_headerPrice",
  "headerSection": "R77P8G_headerSection",
  "inlinePricingNote": "R77P8G_inlinePricingNote",
  "innerTitle": "R77P8G_innerTitle",
  "innerTitleRow": "R77P8G_innerTitleRow",
  "inputLoader": "R77P8G_inputLoader",
  "modalAddedToCartDisclaimer": "R77P8G_modalAddedToCartDisclaimer",
  "modalContainer": "R77P8G_modalContainer",
  "modalContent": "R77P8G_modalContent",
  "pincodeInput": "R77P8G_pincodeInput",
  "pincodeInputShell": "R77P8G_pincodeInputShell",
  "pricingInfoTrigger": "R77P8G_pricingInfoTrigger",
  "productName": "R77P8G_productName",
  "staticSectionTitle": "R77P8G_staticSectionTitle",
  "statusText": "R77P8G_statusText",
  "stickyFooter": "R77P8G_stickyFooter",
  "thumbnailContainer": "R77P8G_thumbnailContainer",
  "usPricingDisclaimer": "R77P8G_usPricingDisclaimer",
});
